import './downloads-search.scss';
import AjaxLoad from '../../utilities/js/ajax-loader';

class DownloadsSearch {
    constructor (element, options) {
        this.$downloadSearch = element;

        const settings = {
            loader: null,
            onSubmit: null,
            content: document.querySelector('[data-download-search="content"]')
        };

        this.$searchInput = this.$downloadSearch.querySelector('[data-download-search="input"]');
        this.$searchSubmitButton = this.$downloadSearch.querySelector('[data-search-button="submit"]');
        this.$searchCancelButton = this.$downloadSearch.querySelector('[data-search-button="cancel"]');
        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        if (this.$downloadSearch) {
            this.bindEvents();
            this.handleButtons();
        }
    }

    // bind events on init and after init
    bindEvents () {
        this.$searchInput.addEventListener('keyup', () => {
            this.handleButtons();
        });

        this.$searchInput.addEventListener('keydown', (e) => {
            const checkLength = this.$searchInput.value;
            // submit form on press enter
            if (e.keyCode === 13) {
                e.preventDefault();

                if (checkLength.length > 0) {
                    this.submitForm();
                } else {
                    window.location.reload();
                }
            }
        });

        this.$searchCancelButton.addEventListener('click', () => {
            this.removeSearchText();
        });

        this.$searchSubmitButton.addEventListener('click', () => {
            this.submitForm();
        });
    }

    // show/hide submit/cancel buttons
    handleButtons () {
        if (this.$searchInput.value.length >= 1) {
            this.$searchCancelButton.classList.remove('is--hidden');
            this.$searchSubmitButton.removeAttribute('disabled');
        } else {
            this.$searchCancelButton.classList.add('is--hidden');
            this.$searchSubmitButton.setAttribute('disabled', false);
        }
    }

    // clean search input field
    removeSearchText () {
        this.$searchInput.value = '';
        this.$searchCancelButton.classList.add('is--hidden');
        this.$searchSubmitButton.setAttribute('disabled', false);
    }

    // form submit event
    setEvents () {
        const selects = this.$downloadSearch.getElementsByTagName('select');
        for (let i = 0; i < selects.length; i++) {
            selects[i].addEventListener('change', () => {
                this.submitForm();
            });
        }
    }

    // form submit function
    submitForm () {
        const $form = document.querySelector('form');
        const formData = new FormData($form);

        new AjaxLoad($form.action, { // eslint-disable-line
            requestMethod: $form.method,
            requestData: formData,
            onSuccess: (resultText) => {
                const $result = document.createElement('div');
                $result.innerHTML = resultText;
                this.settings.content.innerHTML = '';

                if ($result) {
                    this.settings.content.appendChild($result);
                }

                if (typeof this.settings.onSubmit === 'function') {
                    this.settings.onSubmit(this.settings.content);
                }
            }
        });
    }
}

export { DownloadsSearch };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-download-search="search"]');
        $$roots.forEach($root => {
            const $rootAPI = new DownloadsSearch($root);
            $rootAPI.initialize();
        });
    }
});
